import {Toast} from 'vant'
import { listUserAddresses, updateUserAddress, addUserAddress } from '@/api/user'
const state = {
  addressList: [],
  defaultAddress: {},
}
const mutations = {
  setAddressList (state, addressList) {
    state.addressList = addressList
  },
  setDefaultAddress (state, defaultAddress) {
    state.defaultAddress = defaultAddress
  },
}
const actions = {
  async getAddressList ({ state, commit }, params) {
    const { id, callback } = params || {}
    const { success, model, msg } = await listUserAddresses()
    if(!success || !model) return Toast(msg || '获取地址列表失败')
    const list = model.map(item => {
      const addr = {
        areaCode: item.area_code,
        provinceId: item.province_id,
        provinceName: item.province_name,
        cityId: item.city_id,
        cityName: item.city_name,
        countyId: item.county_id,
        countyName: item.county_name,
        address: item.full_address,
        addressDetail: item.address,
        tel: item.mobile_phone,
        name: item.receiver_name,
        id: item.id,
        isDefault: !!item.default_address,
        postalCode: item.postal_code,
        status: item.status,
        updateTime: item.update_time,
        userId: item.user_id,
      }
      if(addr.isDefault && !state.defaultAddress.id) commit('setDefaultAddress', addr)
      return addr
    })
    // 如果有指定id，则设置默认地址
    if (id) {
      const address = list.find(item => item.id === id)
      if(address) commit('setDefaultAddress', address)
    }
    commit('setAddressList', list)
    callback && callback()
  },
  async updateUserAddress ({ dispatch }, params, callback) {
    const { success, msg } = await updateUserAddress(params)
    if(!success) return Toast(msg || '修改地址失败')
    dispatch('getAddressList')
    callback && callback()
  },
  async addUserAddress ({ dispatch }, params, callback) {
    const { success, msg } = await addUserAddress(params)
    if(!success) return Toast(msg || '新增地址失败')
    dispatch('getAddressList')
    callback && callback()
  }
}
const modules = {
}

export default {
  state,
  mutations,
  actions,
  modules,
  namespaced: true
}